import OrbitalTrackSVG from '@public/icons/icon-orbital-track.svg'
import StarAttachmentSVG from '@public/icons/icon-star-attachment.svg'
import SharedSecNavBar from '@src/components/navigationBar/secondary/SharedSecNavBar'
import { NAV_BAR_CONFIG } from '@src/constants/layout'
import { ROUTE } from '@src/constants/route'
import { FC } from 'react'

const NAVIGATION_ITEMS = [
  {
    icon: StarAttachmentSVG,
    route: ROUTE.GODIVERSE_MANAGE_ATTACHMENT,
    translationKey: 'sub_bar.godiverse.star_attachment'
  },
  {
    icon: OrbitalTrackSVG,
    route: ROUTE.GODIVERSE_MANAGE_ORBITAL_TRACK,
    translationKey: 'sub_bar.godiverse.orbital_track'
  }
]

const NavigationBar: FC<Props> = (props: Props) => {
  const { index = 0 } = props

  return (
    <SharedSecNavBar
      height={NAV_BAR_CONFIG.secondary.height}
      index={index}
      navigationItems={NAVIGATION_ITEMS}
    />
  )
}

type Props = {
  index: number
}

export default NavigationBar
